import "./RegistrationComplete.css";
import email_icon from "../../Assets/email_2.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function RegisterComplete() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {}; // safely extract it
  return (
    <div className="container">
      <div className="holder">
        <img className="email_logo" src={email_icon} alt="email icon" />
        <h2>Verify your email address</h2>
        <div className="msg-complete-registration">
          <p>
            We have sent a verification link to <b>{email}</b>
          </p>
          <p>Click the link in your email to verify the account.</p>
          <p>You might need to check yout spam folder</p>
        </div>
        <button
          className="complete_login_button"
          onClick={() => navigate("/login")}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default RegisterComplete;
